import { render, staticRenderFns } from "./my-need.vue?vue&type=template&id=557e5499&scoped=true&"
import script from "./my-need.vue?vue&type=script&lang=js&"
export * from "./my-need.vue?vue&type=script&lang=js&"
import style0 from "./my-need.vue?vue&type=style&index=0&id=557e5499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e5499",
  null
  
)

export default component.exports